import { Line } from '@watcherr/charts';
import * as React from 'react';
import { t } from '~/i18n';
import { formatDateTimeWritten, formatDateWritten, sameOff } from '@ixicare/ui';
import { graphConfig } from '~/store/Graphs/AlertActivity';
import connect from '~/store/connect';
import { State } from '~/store/types';

interface DashboardAlertActivityTooltipProps {
  lines: Line[];
  tooltipWithTimestamp: boolean;
  xValue: Date;
  activeFilter: State['graphs']['alertActivity']['filter'];
}

const DashboardAlertActivityTooltip: React.FC<DashboardAlertActivityTooltipProps> = ({
  lines,
  tooltipWithTimestamp,
  xValue,
  activeFilter,
}) => {
  const values = lines.map((line) => {
    const v = line.dataPoints.find((d) => {
      return sameOff(d.x, xValue, graphConfig[activeFilter].per);
    });
    return {
      color: line.color,
      point: v,
      label: t(`alert.priority.${line.id.toLowerCase()}`),
    };
  });
  return (
    <>
      <h5>{tooltipWithTimestamp ? formatDateTimeWritten(xValue) : formatDateWritten(xValue)}</h5>
      <ul>
        {values.map((v, ix) => (
          <li key={ix}>
            <span
              style={{
                width: 17,
                display: 'inline-block',
                height: 17,
                borderColor: v.color,
                borderStyle: 'solid',
                borderWidth: 4,
                borderRadius: '50%',
                marginRight: 10,
              }}
            ></span>
            <strong style={{ marginRight: 5 }}>{v.point && v.point.y}</strong> <span>{v.label}</span>
          </li>
        ))}
      </ul>
    </>
  );
};

export default connect((store: State) => ({
  activeFilter: store.graphs.alertActivity.filter,
}))(DashboardAlertActivityTooltip);
